import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Select, MenuItem, FormControl, InputLabel,
  Grid, Typography, IconButton, Slide
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { postData, putData } from "../../BaseUrl";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DESIGNATIONS = ["Tamil Speaking", "Tamil Writing", "Tamil Grammar"];

const GRADE_OPTIONS = [
  "MunMazhalai", "Mazhalai",
  "Nilai 1", "Nilai 2", "Nilai 3", "Nilai 4",
  "Nilai 5", "Nilai 6", "Nilai 7", "Nilai 8"
];

const SECTION_OPTIONS = ["A", "B", "C", "D"];

const AddTeacherDialog = ({ open, onClose, teacher, onSuccess }) => {
  const [form, setForm] = useState({
    fullName: "", email: "", phone: "", designation: "", grade: "", section: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const isEdit = Boolean(teacher);

  useEffect(() => {
    if (teacher) {
      setForm({
        fullName: teacher.fullName || teacher.teacherName || teacher.name || "",
        email: teacher.email || "",
        phone: teacher.phone || "",
        designation: teacher.designation || "",
        grade: teacher.grade || "",
        section: teacher.section || ""
      });
    } else {
      setForm({ fullName: "", email: "", phone: "", designation: "", grade: "", section: "" });
    }
    setError("");
  }, [teacher, open]);

  const handleChange = (field) => (e) => {
    setForm(prev => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async () => {
    if (!form.fullName || !form.email || !form.phone || !form.designation) {
      setError("Please fill all required fields");
      return;
    }
    setLoading(true);
    setError("");
    try {
      if (isEdit) {
        await putData(`admin/master/teachers/${teacher.id}`, form);
        onSuccess("Teacher updated successfully");
      } else {
        await postData("admin/master/teachers", form);
        onSuccess("Teacher added successfully");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Operation failed");
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth TransitionComponent={Transition}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6" fontWeight="bold">
          {isEdit ? "Edit Teacher" : "Add Teacher"}
        </Typography>
        <IconButton onClick={onClose}><CloseIcon /></IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField label="Full Name *" fullWidth size="small"
              value={form.fullName} onChange={handleChange("fullName")} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Email *" fullWidth size="small" type="email"
              value={form.email} onChange={handleChange("email")} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Phone *" fullWidth size="small"
              value={form.phone} onChange={handleChange("phone")} />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Designation *</InputLabel>
              <Select value={form.designation} label="Designation *" onChange={handleChange("designation")}>
                {DESIGNATIONS.map(d => (
                  <MenuItem key={d} value={d}>{d}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Grade</InputLabel>
              <Select value={form.grade} label="Grade" onChange={handleChange("grade")}>
                {GRADE_OPTIONS.map(g => (
                  <MenuItem key={g} value={g}>{g}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Section</InputLabel>
              <Select value={form.section} label="Section" onChange={handleChange("section")}>
                {SECTION_OPTIONS.map(s => (
                  <MenuItem key={s} value={s}>{s}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        {error && <Typography color="error" variant="body2" mt={2}>{error}</Typography>}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined"
          sx={{ color: "#f44336", borderColor: "#f44336", textTransform: "none" }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}
          sx={{ background: "linear-gradient(90deg, #4A7BA8, #244C77)", textTransform: "none" }}>
          {loading ? "Saving..." : isEdit ? "Update" : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTeacherDialog;
